/* eslint-disable react/prop-types */
import React from 'react';
export default function StatusIcon({ status }) {
    return (React.createElement("span", { className: " qmb-status" },
        React.createElement("i", { title: status.label, className: status.icon, style: { color: status.color } })));
}
